import React from "react";
import blog from "../assets/blog.png";
import { motion } from "framer-motion";
import { container, leftContent, rightContent } from "../data/anim";
const Home = () => {
  return (
    <motion.div
      className="widthContainer"
      variants={container}
      initial="hidden"
      animate="visible"
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <motion.div variants={rightContent} className="greeting">
        <h1 className="greeting-text"></h1>
        <div>
          {/* <p className="paragraph">
            Hello, I'm Jade Kenneth Darunday sharing my journey experiences of
            learning new technology with web development. As an aspiring web
            developer, making blog posts or synopsis about certain topics is
            also a step of journey.By writing blog posts, i am able to share my
            knowledge and pinpoint my core understanding of the topic.
          </p>
          <p className="paragraph">
            These blog posts serve also as a cheating sheet based on knowledge
            that I gathered from learning. With these blogs we can make a
            community that is able to share our knowledge, issues, objections
            etc. At the end of the blog, knowledge is still guaranteed.
          </p>
          <p className="paragraph">
            And lastly, this blog app also serves as a capability for showcasing
            my abilities in making web applications.
          </p> */}
          <h1 className="greeting-text">Welcome to Blog V1!</h1>
          <p className="paragraph">
            Share your thoughts and let's discuss with different community,
            people interest!
          </p>
        </div>
        <div
          style={
            {
              // marginBottom: "auto",
              // position: "absolute",
              // bottom: "0",
              // left: 0,
            }
          }
        >
          <p>
            Developed by{" "}
            <span style={{ color: "rgb(255, 174, 0)" }}>
              Jade Kenneth Darunday
            </span>
          </p>
        </div>
      </motion.div>
      <motion.div variants={leftContent} className="image-cover">
        <img src={blog} alt="" />
      </motion.div>
    </motion.div>
  );
};

export default Home;
